import React from 'react';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { isAdminAccess, isSystem } from '#component/general/helper';
import {
  StyledListItem,
  StyledListItemText,
  LogTimeWrapper,
  LogItemWrapper,
  LogIconWrapper,
  UnclickableText,
  HeaderContainer,
  ActorText
} from './styles';

const systemActor = () => (
  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
    <AdminPanelSettingsIcon fontSize="medium" />
  </span>
);

const createActor = (log, account) => {
  if (log?.actor && isAdminAccess(account)) {
    if (isSystem(log?.actor.id)) return systemActor();
    return `${log.actor.firstName ?? ''} ${log.actor.lastName ?? ''}`.trim();
  }

  return '';
};

const LogCard = ({ log, account, icon, EventDescriptionComponent, eventFormatter }) => {
  const actor = createActor(log, account);

  return (
    <StyledListItem divider>
      <StyledListItemText
        secondary={
          <LogItemWrapper>
            {icon && <LogIconWrapper>{React.cloneElement(icon, { color: 'secondary' })}</LogIconWrapper>}
            <UnclickableText variant="body1">
              <EventDescriptionComponent log={log} account={account} />
            </UnclickableText>
          </LogItemWrapper>
        }
        primary={
          <HeaderContainer>
            <LogTimeWrapper>
              {eventFormatter(log, account)}
            </LogTimeWrapper>
            {log.actor &&
              <ActorText>
                {actor}
              </ActorText>}
          </HeaderContainer>
        }
      />
    </StyledListItem>
  );
};

export default LogCard;
